import { px } from '@adsk/alloy-react-helpers';

import {
  AlloyLegacyThemeDesignTokens,
  FooterDesignTokens,
  WeaveTheme,
} from '../types';

type WeaveTokens = NonNullable<WeaveTheme['tokens']>;

export const getFooterTokensAlloy = (
  theme: AlloyLegacyThemeDesignTokens,
): FooterDesignTokens => {
  const { typography, spacing } = theme;
  const { colors } = theme.tokens;
  return {
    optionsBar: {
      _: {
        'padding-top': 0,
        'padding-right': px(spacing.XS),
        'padding-bottom': 0,
        'padding-left': px(spacing.XS),
        background: colors.background.secondary.value,
      },
    },
    option: {
      label: {
        _: {
          'font-family': typography.labelSmall.fontFamily,
          'font-weight': `${typography.labelSmall.fontWeight}`,
          'font-size': typography.labelSmall.fontSize,
          'line-height': typography.labelSmall.lineHeight,
          color: colors.text.primary.value,
        },
      },
    },
    selectedCount: {
      _: {
        color: colors.text.secondary.value,
      },
    },
    clearButton: {
      _: {},
    },
  };
};

export const getFooterTokensWeave = (
  tokens: WeaveTokens | undefined,
  fontFamily: string,
): FooterDesignTokens => {
  const semantic = tokens?.semantic;
  const generic = tokens?.generic;
  return {
    optionsBar: {
      _: {
        'padding-top': 0,
        'padding-right': generic?.spacing?.[8],
        'padding-bottom': 0,
        'padding-left': generic?.spacing?.[8],
        background: semantic?.['background-color']?.surface?.[200],
      },
    },
    option: {
      label: {
        _: {
          'font-family': fontFamily,
          'font-weight': '600',
          'font-size': generic?.['font-size']?.[12],
          'line-height': generic?.['line-height']?.[16],
          color: semantic?.['text-color']?.medium?.default,
        },
      },
    },
    selectedCount: {
      _: {
        color: semantic?.['text-color']?.medium?.default,
      },
    },
    clearButton: {
      _: {
        color: semantic?.['text-color']?.link?.default,
      },
    },
  };
};
